import React, { useCallback } from 'react';

import { ReportingContext } from '@ubisend/pulse-errors';

const ReportingProvider = ({ children }) => {
  const report = useCallback(error => {
  }, []);

  const setContext = useCallback((key, value) => {
  }, []);

  const setTag = useCallback((key, value) => {
  }, []);

  const setUser = useCallback(user => {
  }, []);

  const clearScope = useCallback(() => {
  }, []);

  const context = {
    report,
    setContext,
    setTag,
    setUser,
    clearScope
  };

  return (
    <ReportingContext.Provider value={context}>
      {children}
    </ReportingContext.Provider>
  );
};

export default ReportingProvider;
